import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import TermsAndConditions from './components/TermsAndConditions';
import TermsAndConditionsPt from './components/TermsAndConditionsPt';
import PrivacyPolicy from './components/PrivacyPolicy';
import PrivacyPolicyPt from './components/PrivacyPolicyPt';
import CookieBanner from './components/CookieBanner';
import './App.css';

function App(): React.JSX.Element {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/terms-pt" element={<TermsAndConditionsPt />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/privacy-pt" element={<PrivacyPolicyPt />} />
      </Routes>
      <CookieBanner />
    </Router>
  );
}

export default App;
